"use client";

import { Box, Button, Link, Typography } from "@mui/material";

import { useAppDispatch } from "../../../../../redux/store";
import { closeDrawer } from "../../../../../redux/features/drawer/drawerSlice";

function DrawerFooter() {
  const dispatch = useAppDispatch();

  return (
    <Box width="100%" minHeight={100} pt={1} pb={4}>
      <Link
        href="mailto:zavalgt@gmail.com"
        onClick={() => {
          dispatch(closeDrawer());
        }}
      >
        <Button variant="text" fullWidth sx={{ color: "white" }}>
          <Typography component="p" variant="body1">
            zavalgt@gmail.com
          </Typography>
        </Button>
      </Link>
      <Typography
        my={2}
        component="p"
        variant="body1"
        textAlign="center"
        color="white"
      >
        © {new Date().getFullYear()} Derechos Reservados, Gustavo Zavala
      </Typography>
    </Box>
  );
}

export default DrawerFooter;
